export const conversations = {
  android: {
    type: "androidScreen",
    id: "android",
    msg: "",
    next: "student-count",
  },
  name: {
    type: "radio",
    id: "name",
    key: "isOnlineTutor",
    question: {
      msg: "What describes you best?",
      options: [
        {
          value: "I am a YouTuber",
          next: "youtuber-name-exit",
          key: "youtuber",
        },
        {
          value: "I run a coaching center",
          next: "coaching-number-intro",
          key: "coaching-center",
        },
        {
          value: "I teach in a school",
          next: "teacher-consent",
          key: "school-teacher",
        },
        { value: "I am a student", next: "student", key: "student" },
      ],
    },
    next: "coaching-name",
    isShown: true,
  },
  "coaching-name-intro": {
    type: "simple",
    id: "coaching-name-intro",
    msg: "It’s great that you have taken this responsibility of changing the world through your knowledge & wisdom.",
    next: "coaching-name",
    isShown: false,
  },
  "coaching-name": {
    type: "input",
    key: "instituteName",
    subtype: "text",
    id: "coaching-name",
    question: {
      msg: "What is the name of your coaching institute?",
      options: [],
    },
    next: "coaching-size-intro",
    isShown: false,
    switchScreen: true,
  },
  "coaching-number-intro": {
    type: "simple",
    id: "coaching-number-intro",
    msg: "Methods of teaching have changed with time, and it’s important for educators to adapt to these changes.",
    next: "coaching-number-intro-2",
    isShown: false,
  },
  "coaching-number-intro-2": {
    type: "simple",
    id: "coaching-number-intro-2",
    msg: "Let’s start by getting to know you better and help you grow your business",
    next: "coaching-number",
    isShown: false,
  },

  // "coaching-number-intro-2": {
  //   type: "simple",
  //   id: "coaching-number-intro-2",
  //   msg: "We need a few more details to help you with the best tools you need",
  //   next: "coaching-number",
  //   isShown: false,
  // },
  "coaching-number": {
    type: "input",
    subtype: "number",
    key: "phoneNumber",
    id: "coaching-number",
    question: {
      msg: "What’s your contact number?",
      options: [],
    },
    next: "coaching-name",
    isSubmitted: false,
  },

  "coaching-size-intro": {
    type: "simple",
    id: "coaching-size-intro",
    msg: "We need a few more details about your coaching",
    next: "coaching-size",
    isShown: false,
  },

  "coaching-size": {
    type: "radio",
    id: "coaching-size",
    key: "numberOfStudents",
    question: {
      msg: "How many students are you teaching?",
      options: [
        {
          value: "0 - 100 students",
          key: "0-100",
          next: "0-100-intro",
        },
        {
          value: "100 - 250 students",
          key: "100-250",
          next: "100-250-intro",
        },
        { value: "250+ students", key: "250+", next: "250-intro" },
      ],
    },
    next: "coaching-categories",
    isShown: false,
    isSkippable: true,
  },

  "0-100-intro": {
    type: "simple",
    id: "0-100-intro",
    msg: "Great! Educators with up to 100 students make nearly Rs 10 lakh per year at Classplus by selling courses online & taking live classes",
    next: "isRecordedContent",
    isShown: false,
  },
  "100-250-intro": {
    type: "simple",
    id: "100-250-intro",
    msg: "Awesome! You have a chance to make up to Rs 30 lakh in a year just like others who are using Classplus by selling courses online & taking live classes",
    next: "isRecordedContent",
    isShown: false,
  },
  "250-intro": {
    type: "simple",
    id: "250-intro",
    msg: "Wow! Get ready to increase your income upto Rs 60 lakh in a year with Classplus by selling courses online & taking live classes",
    next: "isRecordedContent",
    isShown: false,
  },
  "app-features": {
    type: "multiSelect",
    id: "app-features",
    key: "features",
    question: {
      msg: "How do you want to use the app?",
      options: [
        {
          value: "Sell online courses",
          key: "sell-courses",
        },
        {
          value: "Take live classes",
          key: "live-classes",
        },
        { value: "Conduct online test", key: "online-test" },
        { value: "Batch management", key: "fee-attendance" },
      ],
    },
    next: "app-features-intro-2",
    isShown: false,
    isSkippable: true,
  },

  "coaching-categories": {
    type: "dropdown",
    id: "coaching-categories",
    key: "skillCategory",
    question: {
      msg: "What subjects do you teach?", // new content
      options: [
        {value: "School Board Exams", key: "school-board-exams"},
        {value: "College/University Entrance Exams", key: "college-university-entrance-exams"},
        {value: "College/University Semester Exams", key: "college-university-semester-exams"},
        {value: "Govt Job Exams", key: "govt-job-exams"},
        {value: "CA, CS, CMA, CFA Courses", key: "professional-courses"},
        {value: "Non Academic Courses", key: "non-academic-courses"},
        {value: "Others", key: "others"}
      ],
    },
    next: "app-features-intro-2",
    isShown: false,
    // next: "end",
    // switchScreen: true
  },

  isRecordedContent: {
    type: "radio",
    id: "isRecordedContent",
    key: "isRecordedContent",
    question: {
      msg: "Do you have recorded lectures to start your online coaching?",
      options: [
        {
          value: "Yes, I have",
          key: 1,
          next: "isRecordedYes",
        },
        {
          value: "No, I will create it",
          key: 0,
          next: "isRecordedNo",
        },
      ],
    },
    next: "coaching-categories",
    isShown: false,
    isSkippable: true,
  },
  isRecordedYes: {
    type: "simple",
    id: "isRecordedYes",
    msg: "Awesome! Do you know you can sell these lectures and make more money through your app",
    next: "coaching-categories",
    isShown: false,
  },
  isRecordedNo: {
    type: "simple",
    id: "isRecordedNo",
    msg: "No worries, it’s very easy to create videos on our app. All you need is the content!",
    next: "coaching-categories",
    isShown: false,
  },
  // "app-features-intro": {
  //   type: "simple",
  //   id: "app-features-intro",
  //   msg: "Apart from selling courses online you get various other benefits",
  //   next: "app-features-intro-2",
  //   isShown: false,
  // },
  "app-features-intro-2": {
    type: "simple",
    id: "app-features-intro-2",
    msg: "Classplus provides you with a super app which is an all in one app to help you grow your business",
    next: "state",
    isShown: false,
  },
  "state-intro": {
    type: "simple",
    id: "state-intro",
    msg: "We have more than 1 lakh educators using Classplus for their coachings.",
    next: "state",
    isShown: false,
  },
  state: {
    type: "dropdown",
    id: "state",
    key: "state",
    question: {
      msg: "Select your state to know the leading coachings in your area who are using Classplus",
      options: [],
    },
    next: "end",
    isShown: false,
  },
  "state-youtubers": {
    type: "dropdown",
    id: "state-youtubers",
    key: "state",
    question: {
      msg: "Select your state to know the YouTubers in your area who are using Classplus",
      options: [],
    },
    next: "end",
    isShown: false,
  },
  "youtuber-categories-intro": {
    type: "simple",
    id: "youtuber-categories-intro",
    msg: "Awesome! You are on the right track to become India’s leading content creator",
    next: "youtuber-number",
    isShown: false,
  },
  "youtuber-categories": {
    type: "dropdown",
    id: "youtuber-categories",
    key: "skillCategory",
    question: {
      msg: "What kind of content do you create?", // new content
      options: [
        {value: "School Board Exams", key: "school-board-exams"},
        {value: "College/University Entrance Exams", key: "college-university-entrance-exams"},
        {value: "College/University Semester Exams", key: "college-university-semester-exams"},
        {value: "Govt Job Exams", key: "govt-job-exams"},
        {value: "CA, CS, CMA, CFA Courses", key: "professional-courses"},
        // { value: "Music", key: "music" },
        {value: "Personality Development/Business Coach", key: "personality-development" },
        {value: "Stock and Crypto Trading", key: "stock-trading" },
        // {value: "Photography", key: "photography" },
        // { value: "Language Training", key: "languages" },
        {value: "Fitness", key: "fitness" },
        {value: "Software Training", key: "software-training" },
        {value: "Others", key: "others"}
      ],
    },
    isShown: false,
    next: "end",
    // switchScreen: true
  },
  "youtuber-name-intro": {
    type: "simple",
    id: "youtuber-name-intro",
    msg: "Wow! You have chosen one of the most trending topics these days",
    next: "state-youtubers",
    isShown: false,
  },
  "youtuber-name": {
    type: "input",
    subtype: "text",
    id: "youtuber-name",
    key: "instituteName",
    question: {
      msg: "Please tell us the name of your YouTube channel",
      options: [],
    },
    next: "youtuber-subscribers",
    isShown: false,
  },
  "youtuber-number": {
    type: "input",
    subtype: "number",
    id: "youtuber-number",
    key: "phoneNumber",
    question: {
      msg: "Please share your contact number",
      options: [],
    },
    next: "youtuber-name",
    isSubmitted: false,
  },
  "youtuber-subscribers": {
    type: "radio",
    id: "youtuber-subscribers",
    key: "numberOfStudents",
    question: {
      msg: "How many subscribers do you have?",
      options: [
        {
          value: "Less than 1,000",
          key: "less-than-1000",
          next: "less-than-1000-intro",
        },
        {
          value: "1,000 - 10,000",
          key: "1000-10000",
          next: "1000-10000-intro",
        },
        {
          value: "More than 10,000",
          key: "10000+",
          next: "10000-intro",
        },
      ],
    },
    next: "youtuber-categories",
    isShown: false,
    switchScreen: true,
  },

  "less-than-1000-intro": {
    type: "simple",
    id: "less-than-1000-intro",
    msg: "Great! YouTuber with up to 1000 subscribers make nearly Rs 10 lakh per year at Classplus",
    next: "youtuber-categories",
    isShown: false,
  },
  "1000-10000-intro": {
    type: "simple",
    id: "1000-10000-intro",
    msg: "Awesome! You have a chance to make up to Rs 30 lakh in a year just like others who are using Classplus",
    next: "youtuber-categories",
    isShown: false,
  },
  "10000-intro": {
    type: "simple",
    id: "10000-intro",
    msg: "Wow! Get ready to increase your income up to Rs 60 lakh in a year with Classplus",
    next: "youtuber-categories",
    isShown: false,
  },
  "youtuber-name-exit": {
    type: "simple",
    id: "youtuber-name-exit",
    msg: "There are more than 10,000 YouTube content creators who use Classplus",
    next: "youtuber-number",
    isShown: false,
  },

  "teacher-consent": {
    type: "radio",
    id: "teacher-consent",

    question: {
      msg: "Are you looking to start your own coaching business?",
      options: [
        {
          value: "Yes, Definitely!",
          key: "yes",
          next: "teacher-name-intro",
        },
        {
          value: "I am not sure how to start :(",
          key: "no",
          next: "teacher-name-negative-intro",
        },
      ],
    },
    next: "teacher-name",
    isShown: false,
  },
  "teacher-name-intro": {
    type: "simple",
    id: "teacher-name-intro",
    msg: "That’s great! We need a few more details to guide you with the new online journey!",
    next: "teacher-number",
    isShown: false,
  },
  "teacher-name-negative-intro": {
    type: "simple",
    id: "teacher-name-negative-intro",
    msg: "No worries! We will guide you with your first steps of starting online",
    next: "teacher-number",
    isShown: false,
  },
  "teacher-name": {
    type: "input",
    key: "instituteName",
    subtype: "text",
    id: "teacher-name",
    question: {
      msg: "Please share your name",
      options: [],
    },
    next: "teacher-click-more",
    isShown: false,
  },

  "teacher-number": {
    type: "input",
    subtype: "number",
    key: "phoneNumber",
    id: "teacher-number",
    question: {
      msg: "Please share your number",
      options: [],
    },
    next: "teacher-name",
    isSubmitted: false,
  },
  "teacher-click-more": {
    type: "radio",
    id: "teacher-click-more",
    question: {
      msg: "Do you know with Classplus you can grow your business online and become a national brand easily.",
      options: [
        {
          value: "Tell me more",
          key: "yes",
        },
      ],
    },
    next: "teacher-curious",
  },
  "teacher-curious": {
    type: "radio",
    id: "teacher-curious",
    question: {
      msg: "With Classplus you can take online classes, sell recorded lectures, share assignments and much more!",
      options: [
        {
          value: "I am curious to know more about this",
          key: "yes",
        },
      ],
    },
    next: "teacher-recorded-info",
  },
  "teacher-recorded-info": {
    type: "simple",
    id: "teacher-recorded-info",
    msg: "Teachers with recorded lectures are able to earn extra income by selling online courses",
    next: "state",
    isShown: false,
  },
  student: {
    type: "radio",
    id: "student",
    key: "student-consent",
    question: {
      msg: "Hey, we are delighted to see you here. Does your coaching institute use a mobile app to teach online?",
      options: [
        {
          value: "No, they don't",
          key: "no",
          next: "share-classplus",
        },
        {
          value: "Yes, they do",
          key: "yes",
          next: "share-classplus-yes",
        },
      ],
    },
    next: "share-classplus",
  },

  "share-classplus": {
    type: "simple",
    id: "share-classplus",
    msg: "Ask them to try Classplus and stand a chance to win Rs 500 Amazon Voucher ",
    next: "student-teacher-number",
    isShown: false,
  },

  "student-teacher-number": {
    type: "input",
    subtype: "number",
    id: "student-teacher-number",
    key: "phoneNumber",
    question: {
      msg: "Enter your coaching institute's number here",
      options: [],
    },
    next: "thanks",
    isSubmitted: false,
  },

  "share-classplus-yes": {
    type: "simple",
    id: "share-classplus-yes",
    msg: "That's great to hear! Ask them to try Classplus and stand a chance to win Rs 500 Amazon Voucher",
    next: "student-teacher-number",
    isShown: false,
  },
};